import { render, staticRenderFns } from "./TuNiuApiConfigure.vue?vue&type=template&id=edf83628&scoped=true"
import script from "./TuNiuApiConfigure.vue?vue&type=script&lang=js"
export * from "./TuNiuApiConfigure.vue?vue&type=script&lang=js"
import style0 from "./TuNiuApiConfigure.vue?vue&type=style&index=0&id=edf83628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf83628",
  null
  
)

export default component.exports